import type { TimeRange } from '../../types/monitoring'

const RANGES: { key: TimeRange; label: string }[] = [
  { key: '15m', label: '15m' },
  { key: '1h', label: '1H' },
  { key: '6h', label: '6H' },
  { key: '24h', label: '24H' },
  { key: '7d', label: '7D' },
  { key: '30d', label: '30D' },
]

export function TimeRangeSelector({ value, onChange, disabled }: {
  value: TimeRange
  onChange: (r: TimeRange) => void
  disabled?: boolean
}) {
  return (
    <div className="inline-flex items-center bg-neutral-100 rounded-xl p-1 gap-0.5">
      {RANGES.map((r) => (
        <button
          key={r.key}
          disabled={disabled}
          onClick={() => onChange(r.key)}
          className={`px-3 py-1.5 text-xs font-semibold rounded-lg transition-colors disabled:opacity-50 ${
            value === r.key
              ? 'bg-white text-secondary shadow-sm'
              : 'text-neutral-500 hover:text-neutral-700'
          }`}
        >
          {r.label}
        </button>
      ))}
    </div>
  )
}
